import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import { useDispatch, useSelector } from "react-redux";
import { obtenerGaleriaByPaquete, eliminarGaleriaPaqueteAction } from "../../../ducks/paqueteDuck";
import useCatalogos from "../../../hooks/useCatalogos";
import { APIURL } from "../../../Constantes";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    width: 500,
    height: 350,
  },
  formControl: {
    width: "100%",
    margin: "15px 0"
  },
}));
const Galeria = (props) => {
  const { clavePaquete = "D" } = props;
  const dispatch = useDispatch();
  const galeria = useSelector((state) => state.paquetes.arrayGaleria);
  const classes = useStyles();
  const catTipoImagenes = useCatalogos("TipoImagen");
  const [idTipoImagen, setIdTipoImagen] = useState(1);

  useEffect(() => {
    dispatch(obtenerGaleriaByPaquete(clavePaquete, idTipoImagen));
  }, [dispatch, clavePaquete, idTipoImagen]);

  const handleSelecTipoImagen = (event) => {
    setIdTipoImagen(event.target.value);
  };
  
  const onDelete = (image) =>{
    DialogMessage.fire({
      title: '',
      text: '',
      imageUrl: `${APIURL}/Trip/Package/${clavePaquete}/Imagen/${image.IdPaqueteImagen}`,
      imageWidth: 400,
      imageHeight: 200,
      imageAlt: 'Custom image',
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) =>{
      if (result.isConfirmed) {
        dispatch(eliminarGaleriaPaqueteAction(clavePaquete, image.IdPaqueteImagen)).then((Response) =>{
          ToastMessage.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          )
          dispatch(obtenerGaleriaByPaquete(clavePaquete, idTipoImagen));
        });
      }
    })
  }
  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="lTipoImagen">Tipo de imagen</InputLabel>
          <Select
            labelId="lTipoImagen"
            id="STipoImagen"
            name="tipoImagen"
            value={idTipoImagen}
            onChange={handleSelecTipoImagen}
            label="Vuelo"
          >
            <MenuItem value="0" disabled>
              {"Seleccione una opción"}
            </MenuItem>
            {catTipoImagenes.map((item, index) => (
              <MenuItem key={item.IdTipoImagen} value={item.IdTipoImagen}>
                {`${item.Descripcion}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <ImageList rowHeight={170} className={classes.imageList} cols={3}>
          {galeria.map((item) => (
            <ImageListItem key={item.IdPaqueteImagen} cols={item.cols || 1}>
              <img onClick={() => onDelete(item)} src={`${APIURL}/Trip/Package/${clavePaquete}/Imagen/${item.IdPaqueteImagen}`} alt={item.NombreImagen} />
            </ImageListItem>
          ))}
        </ImageList>
      </Grid>
    </Grid>
  );
};
export default Galeria;
